import { DAYS_OF_WEEK } from '../schemas/enums';
import { serviceHourSchema } from '../schemas/restaurant/serviceHourSchema';

/** Open all day, every day, for PICKUP */
export const serviceHoursPickupAlwaysOpen = serviceHourSchema.decode({
  serviceType: 'PICKUP',
  opens: 'T00:00',
  closes: 'T23:59',
  daysOfWeek: [...DAYS_OF_WEEK],
});

export const serviceHoursPickupAfter6pm = serviceHourSchema.decode({
  serviceType: 'PICKUP',
  opens: 'T18:00',
  closes: 'T23:59',
  daysOfWeek: [...DAYS_OF_WEEK],
});
